/**
 * Defines the type of input for the KendoPromptComponent.
 * 
 * This enum determines whether the prompt input should accept
 * numeric or string values, affecting both the input type
 * and validation behavior.
 */
export enum KendoPromptType {
  /**
   * Represents a numeric input type.
   * The input field will be of type="number".
   */
  Number,
  
  /**
   * Represents a text input type.
   * The input field will be of type="text".
   */
  String,
}
